module.exports = __webpack_public_path__ + "static/media/avatar-default.6cd54454.svg";